var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchPowerup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8333 48.0781L99.1355 39.7714L105.562 46.1978L86.2917 65.4636L67.0214 46.1978L73.4478 39.7714L81.75 48.0781V36.3333C81.75 32.7198 80.3145 29.2542 77.7593 26.699C75.2041 24.1438 71.7386 22.7083 68.125 22.7083H49.9583V13.625H68.125C74.1476 13.625 79.9236 16.0175 84.1822 20.2761C88.4409 24.5348 90.8333 30.3107 90.8333 36.3333V48.0781ZM59.0417 40.875C60.2462 40.875 61.4014 41.3535 62.2531 42.2052C63.1048 43.057 63.5833 44.2121 63.5833 45.4167V90.8333C63.5833 92.0379 63.1048 93.193 62.2531 94.0448C61.4014 94.8965 60.2462 95.375 59.0417 95.375H13.625C12.4205 95.375 11.2653 94.8965 10.4136 94.0448C9.56183 93.193 9.08333 92.0379 9.08333 90.8333V45.4167C9.08333 44.2121 9.56183 43.057 10.4136 42.2052C11.2653 41.3535 12.4205 40.875 13.625 40.875H59.0417ZM54.5 49.9583H18.1667V86.2917H54.5V49.9583Z",
    fill: "#413C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchPowerup);
export default __webpack_public_path__ + "static/media/switch-powerup.ee883cf23783dcb56a0f21ab80bd2a6b.svg";
export { ForwardRef as ReactComponent };